import { useTranslation } from "react-i18next";

interface Props {
  /** `closed` : QR en statut 3, la table est clôturée (tablette : « COMMANDE TERMINEE »). */
  variant?: "invalid" | "closed";
}

export const InvalidQrPage = ({ variant = "invalid" }: Props): JSX.Element => {
  const { t } = useTranslation();
  const closed = variant === "closed";
  return (
    <div className="min-h-screen gradient-warm flex flex-col items-center justify-center px-6 text-center">
      <div className="text-6xl mb-6" aria-hidden="true">
        {closed ? "🧾" : "🤷"}
      </div>
      <h1 className="display-font text-3xl font-semibold text-ink leading-tight">
        {closed
          ? t("invalidQr.closedTitle", "Commande terminée")
          : t("invalidQr.title", "Code introuvable")}
      </h1>
      <p className="text-ink-soft max-w-sm mt-3">
        {closed
          ? t("invalidQr.closedDescription", "Cette table a été clôturée. Merci de votre visite !")
          : t("invalidQr.description", "Ce QR code n'est plus actif. Demandez à votre serveur de vous fournir un nouveau lien.")}
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-8 bg-primary text-white rounded-pill py-3 px-6 font-semibold shadow-warm transition-colors hover:bg-primary-hover"
      >
        {t("invalidQr.retry", "Réessayer")}
      </button>
    </div>
  );
};
